module.exports = __webpack_public_path__ + "img/85.964c56c3.webp";